$(() => {
    initFilterListHover();
    initMobileFilter();
});

  // フィルターリスト ホバー制御
  function initFilterListHover() {
    var $list = $('.filter-main__list');
    var $listItem = $('.filter-main__list > ul > li');
    var $listItemMarker = $('.filter-main__list > ul > li > img');
    var $activeSign = $('.filter-main__list-selected');
    var $spButton = $('.filter__button-sp');

    let isFilterMenuOpen = false;

    // PCフィルターホバー時
    $listItem.hover(
      function() {
        if($spButton.css('display') === 'none') {
          isFilterMenuOpen = true;
          var thisPosition = $(this).offset().left - $list.offset().left;
          var thisWidth = $(this).innerWidth();

          $(this).children().css({
            transform: 'rotate(180deg)'
          });
          $(this).siblings().children().css({
            transform: 'rotate(0deg)'
          });
          $activeSign.css('left', thisPosition);
          $activeSign.css('width', thisWidth);
          $activeSign.css('opacity', 1);

          var showFilter = 'filter__menu-pc-' + $(this).data('desktopMenu');
          var $showFilter = $('.' + showFilter);

          $showFilter.siblings().stop().fadeOut(300);
          $('.filter__menu-pc').stop().slideDown(300);
          $('.filter__menu-pc__inner').stop().fadeIn(400);
          $showFilter.stop().fadeIn(450, function() {
            $showFilter.css('opacity', 1);
          });

          // 閉じる挙動
          function closePcFilter() {
            $activeSign.css('opacity', 0);
            $('.filter__menu-pc__inner').stop().fadeOut(150);
            $showFilter.stop().fadeOut(150);
            $listItemMarker.css({
              transform: 'rotate(0deg)'
            });
            $('.filter__menu-pc').stop().slideUp(150, function(){
              isFilterMenuOpen = false;
            });
          }

          // リサイズでフィルターメニューを閉じる
          $(window).on('resize', function (){
            if($spButton.css('display') === 'none') {
              closePcFilter();
            }
          });

          // フィルターバーの範囲外に出た時閉じる
          let is_mouseMove = false;
          $('.filter-bar').on('mousemove', function (event) {
            if(is_mouseMove) {
              return false;
            }
            if($('.filter-main__list-selected').css('opacity') == 0) {
              return false;
            }

            if ($spButton.css('display') === 'none') {
                is_mouseMove = true;

                let FilterHeight = 0;
                FilterHeight += $('.filter__inner').outerHeight();
                FilterHeight += $('.filter__menu-pc').outerHeight();

                const mouseX = event.pageX - document.querySelector('.filter-main').getBoundingClientRect().left;
                const mouseY = event.pageY - document.querySelector('.filter-bar').getBoundingClientRect().top;

                const iconAreaX = $('.filter-bar').outerWidth() - $('.filter-main').outerWidth();

                // console.log(mouseY);


                if ((mouseY - $(window).scrollTop() > FilterHeight)) {
                  closePcFilter();
                }
                else if((mouseX > ($('.filter-main__list').outerWidth() + iconAreaX)) && mouseY < 70 ) {
                  // フィルターリストの外側、トグルスイッチやソートのところでも閉じる
                  closePcFilter();
                }

                setTimeout(() => {
                    is_mouseMove = false;
                }, 100);
            }

          });

          // フィルターバーの上側でも閉じる
          $('.filter-bar').on('mouseleave', function (event) {
            if ($spButton.css('display') === 'none') {
              closePcFilter();
            }
          });

        }
      });
  }
  initFilterListHover();


  // SP フィルター表示
  function initMobileFilter() {
    var $spButton = $('.filter__button-sp');
    var $spFilterMenu = $('.filter__menu-sp');
    var $spFilterClose = $('.filter__menu-sp__close');
    var $spFilterArea = $('.filter__menu-sp__inner');

    var clickEventType = 'touchend';
    if(window.ontouchend !== null) {
        clickEventType = 'click';
    }

    // スクロール検知
    var isScroll = false;
    var isTouch = false;

    // touchstartとtouchmoveの両方がある時スクロールとみなす
    $(window).on({
      'touchstart': function(){
        isScroll = true;
        isTouch = true;
      },
      'touchmove': function() {
        isScroll = false;
      }
    });

    function resetAccordion() {
      $('.filter__menu-sp__head').css('display','none');
      $('.filter__menu-sp__inner').css('display','none');
      $('.filter__menu-sp__accordion-button').removeClass('active');
    }

    // フィルターのモーダルを呼び出し
    $spButton.on(clickEventType, function() {
      $('body').addClass('noScroll');
      $spFilterMenu.css('display','block');
      $spFilterClose.css('display','block');
      $('.filter__menu-sp__head').css('display','flex');
    });


    $spFilterClose.on(clickEventType, function () {
      $('body').removeClass('noScroll');
      $spFilterMenu.fadeOut(300, function () {
        resetAccordion();
      });
    });

    // アコーディオンの開閉
    $('.filter__menu-sp__accordion-button').on(clickEventType, function () {
      if ($spFilterMenu.css('display') === 'block') {
        if(!isTouch || (isTouch && isScroll)) {
          $(this).next().slideToggle();
          $(this).next().children('.filter__menu-sp__contents').fadeIn(300);
          $(this).toggleClass('active');
          $('.filter__menu-sp__accordion-button').not($(this)).next('.filter__menu-sp__inner').slideUp();
          $('.filter__menu-sp__accordion-button').not($(this)).removeClass('active');

          // アコーディオンの右端をタップで閉じる
          if(!$(this).next().find('div:last-child').hasClass('accordion-close-area')) {
            $(this).next().append('<div class="accordion-close-area"></div>');
            $('.accordion-close-area').on(clickEventType, function () {
              $(this).parents('.filter__menu-sp__inner').slideToggle();
              $(this).siblings('.filter__menu-sp__contents').fadeOut(300);
              $('.filter__menu-sp__accordion-button').removeClass('active');
            });
          }
        }
      }
    });

    // リセットボタン
    $('.jsFilterReset').on(clickEventType, function() {
      $spFilterMenu.find('.jsCheckbox, .jsSwitchCheckbox, .jsPriceRadio').prop('checked', false);
      $spFilterMenu.find('.input__text').val('');
      $('body').removeClass('noScroll');
      $spFilterMenu.fadeOut(300, function () {
        resetAccordion();
      });
    });

    // フィルター決定ボタン（現時点ではダイアログを消すのみ）
    $('.jsFilterSearch').on(clickEventType, function() {
      $('body').removeClass('noScroll');
      $spFilterMenu.fadeOut(300, function () {
        resetAccordion();
      });
    });

    // リサイズ時にレスポンシブの判定をしてフィルターメニューを閉じる
    $(window).on('resize', function (){
      if($spButton.css('display') === 'none') {
        $('body').removeClass('noScroll');
        $spFilterMenu.fadeOut(300, function () {
          resetAccordion();
        });
      }
    });
  }


window.globalFunction = {};
window.globalFunction.initFilterListHover = initFilterListHover;
window.globalFunction.initMobileFilter = initMobileFilter;
